import validateEmail from '../domain/EmailBusinessRules';
import OrderNotFoundError from '../domain/OrderNotFoundError';

export default async function login(repository, { email, order }) {
  validateEmail(email);

  const { hasAccess, token, expires_in: expiresIn } = await repository.loginWithoutIdk({
    email,
    order,
  });

  if (!hasAccess) {
    throw new OrderNotFoundError();
  }

  return { token, expiresIn };
}
